import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.map(question => {
      let { depends_on, ...external_resource_metadata } =
        question?.external_resource?.metadata || {}

      if (question.type === 'external') {
        let { options, metadata, ...rest } = question
        question = rest
      }

      return {
        ...question?.metadata,
        ...(question.type === 'external'
          ? {
              ...question?.external_resource,
              ...external_resource_metadata,
              resource: {
                type: `${question.resource_schema}.${question.resource_table}`,
                id: question.resource_id,
              },
              options: null, // we don't want to bring these back they are held in the external templates definition
              type: 'external', // need to reapply the type
            }
          : {}),
        ...question, // this will re-overwite any idea spread from the external resource
      }
    })
  }, [data])
}
